import { render, staticRenderFns } from "./create-mt.vue?vue&type=template&id=35be13a4&scoped=true"
import script from "./create-mt.vue?vue&type=script&lang=js"
export * from "./create-mt.vue?vue&type=script&lang=js"
import style0 from "./create-mt.vue?vue&type=style&index=0&id=35be13a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35be13a4",
  null
  
)

export default component.exports